import { render, staticRenderFns } from "./InvoiceDialog_Invoice.vue?vue&type=template&id=61ff523f"
import script from "./InvoiceDialog_Invoice.vue?vue&type=script&lang=js"
export * from "./InvoiceDialog_Invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports